import React, { useState } from 'react';
import { withAppContext } from '@ctsu/loader';
import bindLogger from 'helpers/BindLogger';
import { getPIPacketIds } from 'actions/irb';
import TypeAhead from './TypeAhead';

function PacketTypeAhead({
  context, onChange, value, filterBy = {}, onError = () => {}, ...rest
}) {
  const [options, setOptions] = useState();
  const fetchOptions = (searchText) => {
    if (searchText == null || searchText.trim().length < 3) {
      setOptions([]);
      return;
    }
    bindLogger(getPIPacketIds, context)(searchText, filterBy).subscribe((resp) => {
      const { response } = resp;
      if (response != null && response.data.length > 0) {
        const temp = response.data.map((obj) => ({
          ...obj,
          label: obj.packetId,
          value: obj.packetId
        }));
        setOptions(temp);
      } else {
        onError(response);
      }
    });
  };

  return (
    <TypeAhead
      {...rest}
      name="Packet ID"
      value={value}
      options={options}
      onChange={onChange}
      onChangeText={fetchOptions}
    />
  );
}

export default withAppContext(PacketTypeAhead);
